import { render, staticRenderFns } from "./Decline.vue?vue&type=template&id=6c101d23&scoped=true&"
import script from "./Decline.vue?vue&type=script&lang=js&"
export * from "./Decline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c101d23",
  null
  
)

export default component.exports